import { useEffect, useRef, useState } from 'react';
import axios from './httpClient';
import { host } from './webRTC';

export function serializeFilters(filters = {}) {
    const result = {};
    Object.entries(filters).forEach(([key, filter]) => {
        const next = { ...filter };
        if (filter.filterType === 'DATE' || filter.filterType === 'TIME') {
            const value = filter.filterVal || {};
            const convert = input => {
                if (input === undefined || input === null || input === '') return '';
                if (filter.filterType === 'DATE') return input.format ? input.format('YYYY-MM-DD') : new Date(input).toISOString().slice(0, 10);
                const date = new Date(input && input._d ? input._d : input);
                return date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
            };
            let date = value.date;
            if (date && value.comparator === '>= <=') {
                date = filter.filterType === 'DATE'
                    ? { startDate: convert(date.startDate || date.start), endDate: convert(date.endDate || date.end) }
                    : { startTime: convert(date.startTime || date[0]), endTime: convert(date.endTime || date[1]) };
            } else date = convert(date);
            next.filterVal = { ...value, date };
        }
        result[key] = next;
    });
    return result;
}
export default function useServerTable(kind, extra = {}, initialFilters = {}, defaultSort = '_id', defaultOrder = 'desc') {
    const [state, setState] = useState({ page: 1, limit: 10, filters: initialFilters, sortField: defaultSort, sortOrder: defaultOrder });
    const [data, setData] = useState({ rows: [], total: 0, summary: {} });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [revision, setRevision] = useState(0);
    const request = useRef(0);
    const payload = { ...state, filters: serializeFilters(state.filters), timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, ...extra };
    const key = JSON.stringify(payload);
    const extraKey = JSON.stringify(extra);
    useEffect(() => { setState(previous => previous.page === 1 ? previous : { ...previous, page: 1 }); }, [extraKey]);
    useEffect(() => {
        const id = ++request.current;
        const controller = new AbortController();
        let active = true;
        setLoading(true);
        setError('');
        setData(previous => ({ ...previous, rows: [] }));
        const timer = setTimeout(() => {
            axios.post(`${host}/tables/${kind}`, JSON.parse(key), { signal: controller.signal }).then(response => {
                if (!active || id !== request.current) return;
                const result = response.data;
                if (result.total > 0 && (result.page - 1) * result.limit >= result.total) {
                    setState(previous => ({ ...previous, page: Math.ceil(result.total / result.limit) }));
                } else setData(result);
            }).catch(() => { if (active && id === request.current) setError('Не удалось загрузить таблицу. Повторите попытку.'); })
                .finally(() => { if (active && id === request.current) setLoading(false); });
        }, 120);
        return () => { active = false; clearTimeout(timer); controller.abort(); };
    }, [kind, key, revision]);
    const onTableChange = (type, next) => setState(previous => ({
        ...previous,
        page: type === 'filter' || type === 'sort' || (next.sizePerPage !== undefined && next.sizePerPage !== previous.limit) ? 1 : next.page || previous.page,
        limit: next.sizePerPage || previous.limit,
        filters: next.filters || previous.filters,
        sortField: next.sortField || previous.sortField,
        sortOrder: next.sortOrder || previous.sortOrder
    }));
    return { ...data, ...state, loading, error, payload, onTableChange, resetPage: () => setState(previous => ({ ...previous, page: 1 })), reload: () => setRevision(value => value + 1) };
}
